<template>
    <ImpedimentContainer
        title="Problemas específicos de aprendizaje (PEA)"
    >
        <div class="section-group__container">
            <p class="section-group__title">El estudiante:</p>
            <TreeOptions
                v-model="optionsGroup1"
                :is-disabled="isDisabled"
                :show-error="showErrors && !isValidGroup1"
            />
            <p class="disclaimer__text">
                En esta categoría no se incluyen a los estudiantes que presentan problemas en el aprendizaje que son el resultado de impedimentos visuales, auditivos o motores, discapacidad intelectual, disturbios emocionales, problemas de salud o por factores socioculturales, ambientales o económicos.
            </p>
        </div>

        <div class="section-group__container">
            <p class="section-group__title">
                Basado en la información disponible en el expediente, el nivel de aprendizaje que refleja el estudiante es bajo al ser comparado con sus pares en una o más de las siguientes áreas:
            </p>
            <TreeOptions
                v-model="optionsGroup2"
                :cols="2"
                :is-disabled="isDisabled"
                :show-error="showErrors && !isValidGroup2"
            />
        </div>


        <div class="section-group__container">
            <p class="section-group__title">
                De esta manera, los integrantes del COMPU certifican que, de acuerdo con la información obtenida del proceso de observación y evaluación el estudiante:
            </p>
            <TreeOptions
                v-model="optionsGroup3"
                :is-disabled="isDisabled"
                :show-error="showErrors && !isValidGroup3"
            />
        </div>
    </ImpedimentContainer>
</template>
  
<script>
import Error from 'custom-error';
import TreeOptions from './options/TreeOptions.vue';
import ImpedimentMixin from './common/ImpedimentMixin';
import ImpedimentContainer from './common/ImpedimentContainer';

const GROUP1 = [10, 11, 12];
const GROUP2 = [57, 58, 59, 60, 61, 62, 63, 64];
const GROUP3 = [65, 66];

export default {
    name: 'ProblemasEspecificosAprendizaje',
    mixins: [ImpedimentMixin],
    components: {
        Error,
        TreeOptions,
        ImpedimentContainer
    },
    data: () => ({
        showErrors: false,
    }),
    methods: {
        validate() {
            this.showErrors = true;
            return this.isValid;
        }
    },
    computed: {
        optionsGroup1() {
            return this.optionsTree.filter(x => GROUP1.includes(x.id));
        },
        isValidGroup1() {
            return this.optionsGroup1.filter(x => x.selected).length > 0;
        },
        optionsGroup2() {
            return this.optionsTree.filter(x => GROUP2.includes(x.id));
        },
        isValidGroup2() {
            return this.optionsGroup2.filter(x => x.selected).length > 0;
        },
        optionsGroup3() {
            return this.optionsTree.filter(x => GROUP3.includes(x.id));
        },
        isValidGroup3() {
            return this.optionsGroup3.filter(x => x.selected).length > 0;
        },
        isValid() {
            return this.isValidGroup1 & this.isValidGroup2 & this.isValidGroup3;
        }
    },
}
</script>

<style scoped>
.section-group__container {
    margin-bottom: 40px;
}

.section-group__title {
    font-weight: bold;
}

.disclaimer__text {
    margin-top: 30px;
    font-weight: bold;
    font-style: italic;
}
</style>